import React, { FC } from 'react'
import { Tooltip } from 'react-tooltip'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tooltip?: {
    id: string
    text: string
  }
}

export const AiAssistantBottomControl: FC<Props> = ({
  className = 'min-h-[18px] flex items-center justify-center gap-2 text-sm text-center text-v8-blue font-semibold',
  tooltip,
  children,
  ...props
}) => {
  return (
    <>
      <button
        data-tooltip-id={tooltip?.id}
        data-tooltip-content={tooltip?.text}
        data-tooltip-place="top"
        className={className}
        {...props}
      >
        {children}
      </button>
      {tooltip && <Tooltip id={tooltip.id} delayShow={500} />}
    </>
  )
}
